import React, { useState, useEffect } from 'react';
import ClipLoader from "react-spinners/ClipLoader";
import Comm from '../comm/comm';
import { toast } from 'react-toastify';
import ModalUpload from '../controls/ModalUpload';
import ModalSelectDocument from '../controls/ModalSelectDocument';
import Tools from '../tools/tools';
import { Dialog } from 'primereact/dialog';


const ModalMail = (props) => {



    



    return (
        <Dialog header="" visible={props.display} style={{ width: '50vw' }} footer="" onHide={() => props.closeFunc(null)}>
            <div className="container">
                <h2 className="appeal-title mb-5">Заявление за издаване на удостоверение за статут по реда на ЗКН</h2>
                <div className="form-row">
                    <div className="form-group col-md-12">
                        <label>Получател:</label>
                        <p>{props.receiver}</p>

                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group col-md-12">
                        <label>Текст:</label>
                        <p>{props.text}</p>

                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group col-md-12">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>
                                        Документ
                                    </th>

                                </tr>
                            </thead>
                            <tbody>
                                {
                                    props.attachments.map(i =>
                                        <tr key={i.documentId}>
                                            <td>
                                                <a href={'documentcontent?documentId=' + i.documentId} title={i.remark} alt={i.remark}>{i.title}</a>

                                            </td>

                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </Dialog>

    );
}


export default ModalMail;

